import React, { useEffect, useState } from "react"

import './styles.css';
import parse from 'html-react-parser';
import PageTitle from "../../../../components/Accessibility/PageTitle";
import DefaultTextBold from "../../../../components/Accessibility/DefaultTextBold";
import DefaultText from "../../../../components/Accessibility/DefaultText";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { Checkbox, FormControlLabel } from "@mui/material";
import {  sxCheckbox } from "./sxProps";
import { usePrimeiroAgendamentoContext } from "../contexts/PrimeiroAgendamentoContext";
import { retornaTermoResponsabilidadeManualCronicos } from "../../../../services/TermoResponsabilidadeService";
import LoadingApp from "../../../../components/LoadingApp";
import ButtonAccessibility from "../../../../components/Accessibility/ButtonAccessibility";

export const AceiteDeTermos: React.FC = () => {
    const { fontSizeStyleAccessibility } = useAccessibility();
    const { termoResponsabilidade, setTermoResponsabilidade, setSteps, agreed, setAgreed } = usePrimeiroAgendamentoContext()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (!termoResponsabilidade) {
            handleGetTermoResponsabilidade()
        }
    }, [])

    const handleGetTermoResponsabilidade = () => {
        setLoading(true)
        retornaTermoResponsabilidadeManualCronicos()
            .then((response) => setTermoResponsabilidade(response?.data))
            .finally(() => setLoading(false));
    }

    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAgreed(event.target.checked);
    };

    return (
        <div className='page-container'>
            <LoadingApp showLoading={loading} text={'Carregando...'} />
            <PageTitle text="Parabéns!" />
            <DefaultTextBold text="Você foi aceito(a) no Gestão de Crônicos!" />
            <DefaultText text="Leia o manual abaixo e dê o seu aceite para confirmar a sua adesão:" />
            <div className="terms-description-container">
                <div className="terms-description" style={fontSizeStyleAccessibility} tabIndex={0}>
                    {parse(termoResponsabilidade?.descricao ?? '')}
                </div>
            </div>
            <div style={fontSizeStyleAccessibility}>
                <FormControlLabel
                    control={<Checkbox onChange={handleCheck}
                        defaultChecked={agreed} />}
                    label="Li e aceito o manual e a minha inclusão no Programa Gestão de Crônicos" sx={sxCheckbox} />
            </div>
            <div className="terms-of-use-buttons">
                <ButtonAccessibility
                    variant="contained"
                    onClick={() => setSteps((prev) => prev + 1)}
                    fullWidth
                    disabled={!agreed}>
                    CONFIRMAR
                </ButtonAccessibility>
            </div>
        </div>
    )
}